import React from 'react'
import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import { Container, Row, Col } from 'react-bootstrap'
import Dashboard from '../pages/admin/Dashboard'
import Logs from '../pages/admin/Logs'
import Users from '../pages/admin/users/Users'
import Version from '../version'
import Menu from '../components/menus/Menu'
import Sidebar from '../components/menus/Sidebar'


export default function AdminRouter() {
	return (
		<div className='contenido'>
			<Sidebar />
			<div className='content'>
				<Menu />
				<Routes>
					<Route path="/dashboard" element={<Dashboard />} />
					<Route path="/users" element={<Users />} />
					<Route path="/logs" element={<Logs />} />
					<Route path="*" element={<NotFoundPage />} />
				</Routes>
				<Row>
					<Col className='text-center my-3'>
						<Version />
					</Col>
				</Row>
			</div>
		</div>
	)
}